// extracted by mini-css-extract-plugin
export var button = "_nu-2";
export var card = "_nu-0";
export var closeButtonContainer = "_nu-3";
export var iconContainer = "_nu-1";